export default __webpack_public_path__ + "static/media/prefixWorkImg.9c6528ca.png";